<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<ul class="list-inline">
  <li class="list-inline-item" *ngFor="let tag of tags">
    <div class="badge bg-grey">{{ tag }}</div>
  </li>
</ul>
